angular.module('popup.booking', [
  'popup',
  'data.booking',
  'data.employee'
]);
